import React, { useState, useEffect } from "react";
import { getContactInfo, updateContactInfo } from "../../services/contactService";

export default function ManageContact() {
  const [formData, setFormData] = useState({
    address: "",
    email: "",
    phone: "",
    fb_link: "",
    insta_link: "",
    whatsapp: "", // ✅ new field
  });

  const [loading, setLoading] = useState(true);

  // ✅ Fetch contact page data
  useEffect(() => {
    document.title = "Manage Contact | Development Solutions";
    const fetchData = async () => {
      try {
        const res = await getContactInfo();
        setFormData({
          address: res.address ?? "",
          email: res.email ?? "",
          phone: res.phone ?? "",
          fb_link: res.fb_link ?? "",
          insta_link: res.insta_link ?? "",
          whatsapp: res.whatsapp ?? "",
        });
      } catch (err) {
        console.error("❌ Failed to fetch contact page:", err);
        alert("Failed to fetch contact page! (Unauthorized?)");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // ✅ Save contact page
  const saveContactPage = async () => {
    try {
      await updateContactInfo(formData);
      alert("✅ Contact Page updated successfully!");
    } catch (err) {
      console.error("❌ Failed to update contact page:", err);
      alert("Failed to update contact page (Unauthorized?)");
    }
  };

  if (loading) return <p>Loading contact page...</p>;

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">📞 Edit Contact Page</h2>

      <div className="bg-white shadow rounded p-6 mb-6">
        {/* ✅ Address */}
        <label className="block font-semibold mb-1">Address</label>
        <input
          className="w-full border rounded p-2 mb-3"
          value={formData.address}
          onChange={(e) => setFormData({ ...formData, address: e.target.value })}
        />

        {/* ✅ Email */}
        <label className="block font-semibold mb-1">Email</label>
        <input
          className="w-full border rounded p-2 mb-3"
          type="email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        />

        {/* ✅ Phone */}
        <label className="block font-semibold mb-1">Phone</label>
        <input
          className="w-full border rounded p-2 mb-3"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
        />

        {/* ✅ WhatsApp */}
        <label className="block font-semibold mb-1">WhatsApp</label>
        <input
          className="w-full border rounded p-2 mb-3"
          value={formData.whatsapp}
          onChange={(e) =>
            setFormData({ ...formData, whatsapp: e.target.value })
          }
        />

        {/* ✅ Facebook Link */}
        <label className="block font-semibold mb-1">Facebook Link</label>
        <input
          className="w-full border rounded p-2 mb-3"
          value={formData.fb_link}
          onChange={(e) =>
            setFormData({ ...formData, fb_link: e.target.value })
          }
        />

        {/* ✅ Instagram Link */}
        <label className="block font-semibold mb-1">Instagram Link</label>
        <input
          className="w-full border rounded p-2"
          value={formData.insta_link}
          onChange={(e) =>
            setFormData({ ...formData, insta_link: e.target.value })
          }
        />
      </div>

      {/* ✅ SAVE BUTTON */}
      <div className="flex justify-end">
        <button
          onClick={saveContactPage}
          className="px-6 py-2 bg-green-600 text-white rounded hover:bg-green-700"
        >
          Save Contact Page
        </button>
      </div>
    </div>
  );
}